import { useMemo, useState, type ReactNode } from "react";
import { useLocation } from "react-router";
import { Footer } from "./Footer";
import { MarketingAppBar, type MarketingAppBarItem } from "./marketing/MarketingAppBar";

const PUBLIC_NAV_ITEMS: MarketingAppBarItem[] = [
  { label: "Product", href: "/#features" },
  { label: "Privacy", href: "/#privacy" },
  { label: "Prijzen", href: "/#pricing" },
  { label: "FAQ", href: "/#faq" },
];

const PUBLIC_ROUTE_ACTIVE_ITEMS: Record<string, string | undefined> = {
  "/": undefined,
  "/privacy": undefined,
  "/terms": undefined,
  "/trust": undefined,
  "/sub-processors": undefined,
};

interface Props {
  children: ReactNode;
}

export function PublicPageLayout({ children }: Props) {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const activeItem = useMemo(
    () => PUBLIC_ROUTE_ACTIVE_ITEMS[location.pathname],
    [location.pathname],
  );

  return (
    <div className="cs-marketing flex min-h-screen flex-col bg-slate-50">
      <MarketingAppBar
        items={PUBLIC_NAV_ITEMS}
        activeItem={activeItem}
        mobileMenuOpen={mobileMenuOpen}
        navScrolled={false}
        onToggleMenu={() => setMobileMenuOpen((current) => !current)}
      />
      <main className="flex-1 px-4 pb-10 pt-28 sm:px-6 sm:pt-32">{children}</main>
      <Footer />
    </div>
  );
}
